export const GOOGLE_API_KEY = "AIzaSyCzvycKpA1ilBS0tyw_CvjQL1LJSYXdj5E";
export const BACKEND_URL = "https://fleet.yoksghana.com/api/web/v1/";

export const FMS_BACKEND_URL = "https://fleet.yoksghana.com/api/v1/";
export const PAY_STACK_PK_KEY = "pk_test_a70c20fc7e2c5f4cb8cba81dca71522d6edcd422";
export const FMS_MEDIA = "https://fleet.yoksghana.com";
